import React, { useCallback, useMemo } from "react";
import { SearchOption, TypeaheadInput, AgGridReact, AgGrid } from "@jsq/ds/core";
import { useGetArenasLazyQuery } from "../../../graphql/supergraph.index";
import { clientContext } from "../../../utils/graphql_utils";
import { filterText } from "../styles_vanilla.css";
import { ArenaEdgeType } from "./types";

export const ClientFilter = (filterParams: AgGridReact.CustomFilterProps) => {
  const { onModelChange, getValue } = filterParams;
  const [fetchArenasQuery, { data, loading }] = useGetArenasLazyQuery();

  const handleSelection = useCallback(
    (value?: SearchOption) => {
      onModelChange(value?.id);
    },
    [onModelChange],
  );

  const arenaList = useMemo(
    () =>
      data?.arenas?.edges.map((arena: ArenaEdgeType) => ({
        id: arena.node.id,
        label: arena.node.name,
      })) || [],
    [data],
  );

  const handleDebouncedSearch = useCallback(
    async (value?: string) => {
      if (value?.length) {
        await fetchArenasQuery({
          context: clientContext(),
          variables: { searchTerm: value },
          fetchPolicy: "no-cache",
        });
      } else {
        onModelChange(null);
      }
    },
    [fetchArenasQuery, onModelChange],
  );

  // Note: doesFilterPass is only called with the Client-Side Row Model.
  const doesFilterPass = useCallback(
    (params: AgGrid.IDoesFilterPassParams) => {
      return getValue(params.node) == filterParams.model;
    },
    [getValue, filterParams],
  );

  // register filter callbacks with the grid
  AgGridReact.useGridFilter({ doesFilterPass });
  return (
    <TypeaheadInput
      className={filterText}
      data-testid="client-filter"
      isClearable
      isFullWidth
      isLoading={loading}
      options={arenaList}
      onSelectOption={handleSelection}
      onDebouncedSearch={handleDebouncedSearch}
      placeholder="Search for a client"
    />
  );
};
